import routeProviderConfig from './configs/routeProvider.config';

import campaign from './components/campaign/campaign.component';
import campaigns from './components/campaigns/campaigns.component';

/**
 * @ngdoc overview
 * @name campaigns
 * @description
 * This module handles everything for the Campaigns section.
 */
const campaignsModule = angular.module('campaigns', [])
.config(routeProviderConfig)
.component('campaign', campaign)
.component('campaigns', campaigns);

export default campaignsModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/campaigns/index.js